import React from 'react';
import Meta from '../components/Meta';
import SamplesDashboard from '../components/SamplesDashboard';

function SamplesPage() {
  return (
    <>
      <Meta title="Samples Dashboard" />
      <SamplesDashboard />
    </>
  );
}

export default SamplesPage;
